import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody
} from "../../APIHelpers/Responses";

export const categoryServices = {
  addNewCategory,
  updatedCategory,
  softDeleteRestoreCategory,
  deleteCategory,
  getCategoryList,
};

// Add New Bank Meta
async function addNewCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewCategory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Bank Meta
async function updatedCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Soft Delete & Restore Bank Meta
async function softDeleteRestoreCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Delete Bank Meta
async function deleteCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteCategory`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get All Bank Meta
async function getCategoryList(status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCategoryList/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getCategoryList/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}